<template>
   <el-dialog title="提示" :visible.sync="Visible"  @close="close"
      width="900px" >
        <el-form ref="form"  :model="form" label-width="70px">
            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="车辆品牌">
                  <el-select v-model="form.BrandVal" clearable @change="brandChange" @clear="clearType" placeholder="请选择品牌">
                    <el-option
                      v-for="item in options.Brand"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="车型" >
                  <el-select v-model="form.ModelVal" clearable @change="modelChange"  placeholder="请选择车型">
                    <el-option
                      v-for="item in options.Model"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="车辆型号">
                 <el-select v-model="form.TypeVal" clearable placeholder="请先选择品牌">
                    <el-option
                      v-for="item in options.Type"
                      :key="item.id"
                      :label="item.type"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
          
              <el-col :span="3">
                <el-button type="primary" @click="TabelCarNum">搜索</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="padding:0 20px">
              <el-table
                :data="tableData"
                highlight-current-row
                @current-change="handleCurrentChange"
                height="300px"
                style="width: 100%">
                 <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="frame_num"
                  label="车架号"
                  align="center"
                  width="180">
                </el-table-column> -->
                <el-table-column
                  prop="brand"
                  label="车辆品牌"
                  align="center"
                  width="180">
                </el-table-column>
                 <el-table-column
                  prop="license_num"
                  label="车牌号"
                  align="center"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="车辆型号"
                  align="center"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="model"
                  align="center"
                  label="车型">
                </el-table-column>
                <el-table-column  v-if="false"
                    prop="belong_userid"
                    align="center"
                    label="车辆所属用户">
                </el-table-column>
              </el-table>
            </el-row>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitHandel">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import { dataSelectBrand,dataSelectType,dataSelectModel} from '@/api/tbox'
import { geteSelectCarInfo } from '@/api/lease'
import { queryCarTypeData} from '@/api/system'
export default {
  data(){
    return{
      Visible:true,
      options:{
        Brand:[],
        Model:[],
        Type:[],
      },
      form:{
          BrandVal:'',
          ModelVal:'',
          TypeVal:''
      },
      tableData:[],
      formData:{},
      brandModelData:[] ,
      modelTypeData:[],
     
    }
  },
  created(){
    this.SelectBrand()
    this.getBrandAndTypeData();
    this.TabelCarNum()
  },
  methods:{
    clearType(){
        this.options.Model = []
            this.form.ModelVal = null
            this.options.Type = []
            this.form.TypeVal = null
    },
    handleCurrentChange(val) {
      this.formData = val
    },
    close(){
      this.$parent.Visible= false
    },
    submitHandel(){
      this.close()
      this.$emit('parent',this.formData)
    },
    TabelCarNum(){
      const data = {
        brandCode:this.form.BrandVal,
        typeCode:this.form.TypeVal,
        modelCode:this.form.ModelVal,
      }
      geteSelectCarInfo(data).then(res=>{
        this.tableData =res.data.content
      })
    },
    // 品牌
    SelectBrand(){
      dataSelectBrand().then(res=>{
        this.options.Brand =res.data.content
      })
    },
    //车型 
    // SelectType(){
    //   dataSelectType({id:this.form.BrandVal}).then(res=>{
    //     this.options.Type = res.data.content
    //   })
    // },
    // //型号
    // SelectModel(){
    //   dataSelectModel().then(res=>{
    //     this.options.Model =res.data.content
    //   })
    // },
    // BrandHandel(){
    //   this.SelectType()
    // },
    getBrandAndTypeData(){
         queryCarTypeData().then(res=>{
          this.brandModelData =  res.data.brandModel
          this.modelTypeData =  res.data.modelType
        })
    },
      //车辆品牌选中事件
    brandChange(){
        let brand = this.form.BrandVal
        if(brand !=null && brand !=''){
            this.options.Model = []
            this.form.ModelVal = null
            this.options.Type = []
            this.form.TypeVal = null
            this.brandModelData.forEach(el =>{
                if(el.brand === brand){
                  this.options.Model.push(el)
                }
            })
        }
    },
    //车型选中事件
    modelChange(){
        let model = this.form.ModelVal
        if(model !=null && model !=''){
          this.options.Type = []
          this.form.TypeVal = null
          this.modelTypeData.forEach(el =>{
              if(el.car_model === model){
                this.options.Type.push(el)
              }
          })
        }
    },
  }
}
</script>

<style>

</style>
